/**
 * 轮播图管理api
 */
export default {
   // 轮播图列表
  getCarouselList: '/adCarousel/pageList',
  // 删除轮播图
  deleteCarouselList: '/adCarousel/delete',
  // 新增轮播图
  saveCarouselList: '/adCarousel/save',
  // 修改轮播图
  updateCarouselList: '/adCarousel/update',
};
